import { render, staticRenderFns } from "./artist-filter-form.vue?vue&type=template&id=4be66f6a"
import script from "./artist-filter-form.vue?vue&type=script&lang=js"
export * from "./artist-filter-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports